import React from "react";

import type { ServerDataSuccess } from "./route";

import {
  AnnotatedImageCarousel,
  ShopifyRichText,
  CarouselSection,
  Image,
  ImageModal,
  useModal,
  Zoomable,
} from "@bared/ui";

export interface HowToStyleSectionProps {
  howToStyleImages: ServerDataSuccess["howToStyleImages"];
  howToStyleContent: ServerDataSuccess["howToStyleContent"];
}

export function HowToStyleSection(props: HowToStyleSectionProps) {
  return (
    <div id="how_to_style_section" className="scroll-mt-10">
      <MainSection {...props} />
      <Modal {...props} />
    </div>
  );
}

function MainSection({
  howToStyleImages,
  howToStyleContent,
}: HowToStyleSectionProps) {
  const { showModal } = useModal();
  return (
    <AnnotatedImageCarousel
      ariaLabel="How to style images"
      title="How to Style"
      textContent={
        <div>
          <ShopifyRichText content={howToStyleContent} />
        </div>
      }
    >
      {howToStyleImages.map((image, index) => (
        <CarouselSection
          className="aspect-4-5 [&_img]:object-cover"
          index={index}
          key={`${index}-${image.alt}`}
          onClick={() =>
            showModal("how-to-style-modal", { initialIndex: index })
          }
        >
          <Image {...image} sizes="100vw" loading="eager" aspectRatio="4/5" />
        </CarouselSection>
      ))}
    </AnnotatedImageCarousel>
  );
}

function Modal({ howToStyleImages }: HowToStyleSectionProps) {
  return (
    <ImageModal id="how-to-style-modal" ariaLabel="How to style images">
      {howToStyleImages.map((image, index) => (
        <CarouselSection
          className="aspect-4-5"
          index={index}
          key={`${index}-${image.alt}`}
        >
          <Zoomable>
            <Image {...image} sizes="100vw" loading="eager" aspectRatio="4/5" />
          </Zoomable>
        </CarouselSection>
      ))}
    </ImageModal>
  );
}
